import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'actions/modal';
import { useMappingLogPatch } from 'actions/auto-mapping';
import { ACTIONS as notificationActions } from 'actions/notification';
import { invalidateMappingLogs } from 'actions/auto-mapping';
import { get as getConfig } from 'actions/configs';
import { MAPPING_REJECTION_REASONS_KEY } from 'constants/auto-mapping';
import { store } from 'redux-rest-reducer';

const useLogic = ({ mappingId, otherTeachers }) => {
  const [reason, setReason] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const dispatch = useDispatch();
  const configsStore = useSelector(({ configs }) => configs);

  useEffect(() => {
    dispatch(getConfig?.(MAPPING_REJECTION_REASONS_KEY));
  }, [dispatch]);

  const options = store.get(configsStore, MAPPING_REJECTION_REASONS_KEY)?.data ?? [];
  const showOtherTeachersFound = otherTeachers?.length > 0;

  const onMappingFeedbackComplete = errorMessage => {
    if (errorMessage) {
      dispatch({
        type: notificationActions.SHOW_NOTIFICATION,
        payload: {
          text: 'Something went wrong.',
          duration: 10,
          showCloseIcon: true,
        },
      });
    } else {
      invalidateMappingLogs?.();
      if (showOtherTeachersFound) {
        setSubmitSuccess(true);
      } else {
        dispatch(closeModal?.());
      }
    }
  };

  const { patch: mappingResultFeedbackPatch, isProcessing } = useMappingLogPatch({
    onComplete: onMappingFeedbackComplete,
  });

  const handleSubmit = () => {
    const data = {
      reason,
    };
    mappingResultFeedbackPatch?.(mappingId, data);
  };

  return {
    reason,
    setReason,
    handleSubmit,
    isBusy: isProcessing,
    options,
    submitSuccess,
    showOtherTeachersFound,
  };
};

export default useLogic;
